import {
  AffectiveIndex,
  ValueCategoryIndex,
} from 'apps/web/enums/iPlanObjectives/categories.enum';
import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';

import {
  ENVIRONMENT_CENTERED_VALUES,
  GOD_CENTERED_VALUES,
  NATION_CENTERED_VALUES,
  PEOPLE_CENTERED_VALUES,
} from './additional-options';
import * as digital from './digital';
import * as standard from './standard';

export const createAffectiveCategoryLabels = () => [
  'Characterizing',
  'Organizing',
  'Valuing',
  'Responding',
  'Receiving',
];

export const createValueCategoryLabels = () => [
  'God-centered',
  'People-centered',
  'Environment-centered',
  'Nation-centered',
];

export const getAffectiveVerbs = (
  isDigital: boolean,
): Record<number, BehavioralVerb[]> => {
  return isDigital
    ? {
        [AffectiveIndex.Receiving]: digital.DIGITAL_RECEIVING_VERBS,
        [AffectiveIndex.Responding]: digital.DIGITAL_RESPONDING_VERBS,
        [AffectiveIndex.Valuing]: digital.DIGITAL_VALUING_VERBS,
        [AffectiveIndex.Organizing]: digital.DIGITAL_ORGANIZING_VERBS,
        [AffectiveIndex.Characterizing]: digital.DIGITAL_CHARACTERIZING_VERBS,
      }
    : {
        [AffectiveIndex.Receiving]: standard.STANDARD_RECEIVING_VERBS,
        [AffectiveIndex.Responding]: standard.STANDARD_RESPONDING_VERBS,
        [AffectiveIndex.Valuing]: standard.STANDARD_VALUING_VERBS,
        [AffectiveIndex.Organizing]: standard.STANDARD_ORGANIZING_VERBS,
        [AffectiveIndex.Characterizing]: standard.STANDARD_CHARACTERIZING_VERBS,
      };
};

export const getValuesByCategory = (): Record<number, BehavioralVerb[]> => {
  return {
    [ValueCategoryIndex.GodCentered]: GOD_CENTERED_VALUES,
    [ValueCategoryIndex.PeopleCentered]: PEOPLE_CENTERED_VALUES,
    [ValueCategoryIndex.EnvironmentCentered]: ENVIRONMENT_CENTERED_VALUES,
    [ValueCategoryIndex.NationCentered]: NATION_CENTERED_VALUES,
  };
};
